import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { FormatarCpfCnpj } from "../utils/documento-fiscal.utils";

@Injectable()
export class DocumentoInterceptor implements HttpInterceptor {

  private isPlainObject(value: any): boolean {
    return value !== null && typeof value === 'object' && (value.constructor === Object || Array.isArray(value));
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // ===== Intercepta a REQUISIÇÃO =====
    let request = req;

     // Intercepta e formata o body (apenas objetos JSON planos e arrays)
     if (req.body && this.isPlainObject(req.body)) {
      request = request.clone({
        body: FormatarCpfCnpj(structuredClone(req.body)),
      });
    }

    // Intercepta e formata os params
    if (req.params) {
      const paramsObj: { [key: string]: string } = {};
      req.params.keys().forEach((key) => {
        paramsObj[key] = req.params.get(key) || '';
      });

      const formattedParamsObj = FormatarCpfCnpj(paramsObj);

      let formattedParams = new HttpParams();
      Object.keys(formattedParamsObj).forEach((key) => {
        formattedParams = formattedParams.set(key, formattedParamsObj[key]);
      });

      request = request.clone({
        params: formattedParams,
      });
    }

    // Intercepta e formata os headers
    if (req.headers) {
      const headersObj: { [key: string]: string } = {};
      req.headers.keys().forEach((key) => {
        headersObj[key] = req.headers.get(key) || '';
      });

      const formattedHeadersObj = FormatarCpfCnpj(headersObj);

      let formattedHeaders = req.headers;
      Object.keys(formattedHeadersObj).forEach((key) => {
        formattedHeaders = formattedHeaders.set(key, formattedHeadersObj[key]);
      });

      request = request.clone({
        headers: formattedHeaders,
      });
    }

    // ===== Intercepta a RESPOSTA =====
    return next.handle(request).pipe(
      map((event) => {
        if (event instanceof HttpResponse && event.body && this.isPlainObject(event.body)) {
          const bodyFormatado = FormatarCpfCnpj(structuredClone(event.body));
          return event.clone({
            body: bodyFormatado,
          });
        }

        return event;
      }),
    );
  }
}
